import React from 'react';

const defaultValue = {
  projectName: '비상교육'
};
export const VisangAppContext = React.createContext(defaultValue);
